import { Col, Input, Label, Row } from "reactstrap";
import { Products, Shipping, Subtotal, Total } from "../../../../constants";
import { useAppSelector } from "../../../../reduxToolkit/hooks";
import { getCartTotal, getallCardTotal } from "../../../../utils/ecommerce";
import { dynamicNumber } from "../../../../utils";
import { CashOnDelivery, CheckPayments, Paypal } from '../../../../constants'
import { dynamicImage } from '../../../../utils'
import { Image } from "../../../../coreComponents/Image";

// This component displays the checkout details, including the order summary, shipping options, and payment methods.
const Details = () => {
  const { cart } = useAppSelector((state) => state.cartData);

  return (
    <Col xl="6" sm="12">
      <div className="checkout-details">
        <div className="order-box">
          <div className="title-box">
            <div className="checkbox-title">
              <h3>{Products} </h3>
              <span>{Total}</span>
            </div>
          </div>
          <ul className="qty">
            {cart && cart.map((data, i) => (<li key={i}>{data.name} x {data.total} <span>$ {getCartTotal(data)}</span></li>))}
          </ul>
          <ul className="sub-total">
            <li>{Subtotal} <span className="count">$ {getallCardTotal(cart)}</span></li>
            <li className="shipping-class">
              {Shipping}
              <div className="shopping-checkout-option">
                {dynamicNumber(2).map((item, index) => (
                  <Label className="d-block" htmlFor={`chk-ani${item}`} key={index}>
                    <Input className="checkbox_animated" id={`chk-ani${item}`} type="checkbox" defaultChecked={item === 1 ? true : false} />
                    {`Option${item}`}
                  </Label>
                ))}
              </div>
            </li>
          </ul>
          <ul className="sub-total total">
            <li>{Total} <span className="count">$ {getallCardTotal(cart)}</span></li>
          </ul>
          <div className="animate-chk">
            <Row>
              <Col>
                <Label className="d-block" for="edo-ani">
                  <Input className="radio_animated" id="edo-ani" type="radio" name="rdo-ani" defaultChecked />{CheckPayments}
                </Label>
                <Label className="d-block" for="edo-ani1">
                  <Input className="radio_animated" id="edo-ani1" type="radio" name="rdo-ani" />{CashOnDelivery}
                </Label>
                <Label className="d-block" for="edo-ani2">
                  <Input className="radio_animated" id="edo-ani2" type="radio" name="rdo-ani" defaultChecked />{Paypal}
                  <Image className="img-paypal" src={dynamicImage(`checkout/paypal.png`)} alt="paypal" />
                </Label>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </Col>
  );
};

export default Details;